import { Container, Col, Row } from "reactstrap";
import { BreadcrumbItem } from "reactstrap";
import { Component as Form } from "@repoflow/form-schema";
import * as Notify from "@repoflow/form-schema/notify";
import {
  Mutation,
  Button,
  useSectionContext,
} from "@repoflow/components/section";
import { CancellableContent } from "@repoflow/components/content-cancel";
import * as QueriesQL from "queries/bucket-file";
import { PRIVATE, isVisibility } from "@common/schema/bucket-file/visibility";

export const Sidebar = () => null;

export const Indice = () => (
  <>
    <BreadcrumbItem>Edit</BreadcrumbItem>
  </>
);

export const Content = ({ history, match: { params } }) => {
  const { base, values: file } = useSectionContext();

  return (
    <Mutation
      // Seeded explicitly rather than from the row, for one field's sake. A file
      // uploaded before `visibility` existed carries null, and a select shows its
      // first option whatever the form is holding — so the control would read
      // "private" while the form carried nothing, and choosing private would
      // submit that nothing back. Normalising here means the form always holds
      // the string the control is displaying.
      initial={{
        description: file.description,
        tags: file.tags,
        visibility: isVisibility(file.visibility) ? file.visibility : PRIVATE,
      }}
      target={{ $ref: "/Public/BucketFile/Update" }}
      mutation={QueriesQL.edit}
      update={QueriesQL.update(params)}
      onMutate={({ handler, state: { values } }) => {
        handler({ variables: { ...params, input: values } });
      }}
      onCompleted={() => {
        history.replace(base);
      }}
      onError={(error) => {
        Notify.error(error.toString());
      }}
    >
      {MutationHandler}
    </Mutation>
  );
};

const MutationHandler = ({ target, state, schema, mutate }) => {
  const { values, setValues } = state;

  const formProps = {
    schema,
    target,
    onSubmit: () => {
      mutate();
    },
    onChange: (values) => {
      setValues(values);
    },
    config: {
      "/Public/BucketFile/Update": {
        fields: ["description", "tags", "visibility"],
      },
    },
    values,
  };

  return (
    <CancellableContent>
      <Container className="mt-4">
        <Row>
          <Col>
            <Form {...formProps}>
              <Button type="submit">Edit</Button>
            </Form>
          </Col>
        </Row>
      </Container>
    </CancellableContent>
  );
};
